<template>
  <login></login>
</template>

<script>
import CompLogin from "./Login";

export default {
  components: {
    login: CompLogin,
  },
};
</script>
